import { Component, ViewContainerRef } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, PopoverController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { ColorPickerService, Cmyk } from 'ngx-color-picker';
import { PopupPage } from '../../popup/popup';

/**
 * Generated class for the EditorganizationunitPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editorganizationunit',
  templateUrl: 'editorganizationunit.html',
})
export class EditorganizationunitPage {
  loadingData: boolean = false;
  Organisations: any;
  gr: any;
  cb: any;
  Title = ''
  orgcode: string = ''
  orgname: string = ''
  orgdesc: string = ''
  boja: boolean = false
  operationids = 0
  operations = []
  selectedOpIds = []
  selectedOpName = ''


  public toggle: boolean = false;

  public rgbaText: string = 'rgba(165, 26, 214, 0.2)';

  public arrayColors: any = {
    color1: '#2883e9',
    color2: '#e920e9',
    color3: 'rgb(255,245,0)',
    color4: 'rgb(236,64,64)',
    color5: 'rgba(45,208,45,1)'
  };

  public selectedColor: string = 'color1';

  public color1: string = '#2889e9';
  public color2: string = '#e920e9';
  public cmykColor: Cmyk = new Cmyk(0, 0, 0, 0);


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController, public vcRef: ViewContainerRef, private cpService: ColorPickerService, public popoverCtrl: PopoverController) {
    this.gr = navParams.get('gr')
    this.cb = navParams.get('cb');

    // console.log('bosko kocev',this.gr)
    if (this.gr.id == -1) {
      this.Title = this.dic.l["addneworganizationunit"]
      this.color2 = '#1b1a1b'
      if (this.gn.clientsettings.clienttypeid + '' == '4') {
        this.selectedOpName = '-- ' + this.dic.l["SelectOperation"] + ' --'
      }
    } else {
      this.Title = this.dic.l["editorg"]
      this.orgcode = this.gr.code
      this.orgname = this.gr.name
      this.orgdesc = this.gr.description
      this.color2 = this.gr.color
      if (this.gn.clientsettings.clienttypeid + '' == '4') {
        this.selectedOpIds = this.gr.operidsarray
        //debugger
        this.selectedOpName = this.gr.opernames
        if (this.selectedOpName.length == 0) {
          this.selectedOpName = '-- ' + this.dic.l["SelectOperation"] + ' --'
        }
      }

      if (this.color2 != null) {
        this.boja = true
      }
      if (this.color2 == null) {
        this.color2 = '#1b1a1b'
      }
    }
  }

  public onEventLog(event: string, data: any): void {
    console.log(event, data);
  }

  public onChangeColorCmyk(color: string): Cmyk {
    const hsva = this.cpService.stringToHsva(color);

    if (hsva) {
      const rgba = this.cpService.hsvaToRgba(hsva);

      return this.cpService.rgbaToCmyk(rgba);
    }

    return new Cmyk(0, 0, 0, 0);
  }

  public onChangeColorHex8(color: string): string {
    const hsva = this.cpService.stringToHsva(color, true);

    if (hsva) {
      return this.cpService.outputFormat(hsva, 'rgba', null);
    }

    return '';
  }

  ionViewDidLoad() {
    // console.log(this.color44, 'daj da vidam')
    this.loadColutures()
  }

  loadColutures() {
    var _that = this
    // this.loadingData = true
    // console.log()
    this.gn._Post('/api/gn/getcolutures', { cid: this.gn.crypt(this.gn.user.ClientId), indoor: this.gn.crypt(this.gn.clientsettings.indoor) }, function (_data) {
      _that.operations = _data.B
      // for (let i = 0; i < this.selectedOpIds.length; i++) {

      // }
      _that.loadingData = false
      // console.log(_data  )
    })
  }


  pickOperation(_ev) {
    var selC = []
    var _that = this
    //debugger
    if (this.selectedOpIds == undefined) {
      this.selectedOpIds = []
    }
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'components2', selected: '', arrayData: this.operations, selCompId: this.selectedOpIds, callback: function (_c, _p) {
        _that.selectedOpIds = [];
        selC = [];
        _that.selectedOpName = '';
        for (var i = 0; i < _p.length; i++) {
          if (_p[i].ch) {
            _that.selectedOpIds.push(_p[i].id)
            selC.push(_p[i].name)
          }
        }
        _that.selectedOpName = selC.join(', ')
      }
    });
    popover.present({ ev: _ev });
  }

  // probnasave() {
  //   this.color2
  //   // console.log(this.colorbroj, 'daj da vidam')

  // }

  Save() {

    if (this.orgname == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterorgunitname"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.boja == false) {
      this.color2 = null
    }

    var _that = this;
    var dat = {
      code: this.gn.crypt(this.orgcode),
      name: this.gn.crypt(this.orgname),
      description: this.gn.crypt(this.orgdesc),
      cid: this.gn.crypt(this.gn.user.ClientId),
      color: this.gn.crypt(this.color2),
      operations: this.gn.crypt(this.selectedOpIds.join(',')),

    }
    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/addneworganisation', dat, function (_data) {
      _that.gn.Organisations.push(_data[0]);
      _that.navCtrl.pop();
      _that.cb();
      //_that.gn.enableBtn();
      _that.gn.tfBtn = false;
    })

  }

  Edit() {
    if (this.boja == false) {
      this.color2 = ''
    }
    var _that = this;
    var dat = {
      orgid: this.gn.crypt(this.gr.id),
      code: this.gn.crypt(this.orgcode),
      name: this.gn.crypt(this.orgname),
      description: this.gn.crypt(this.orgdesc),
      cid: this.gn.crypt(this.gn.user.ClientId),
      color: this.gn.crypt(this.color2),
      operations: this.gn.crypt(this.selectedOpIds.join(',')),
    }
    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/editorganisation', dat, function (_data) {
      for (var i = 0; i < _that.gn.Organisations.length; i++) {
        if (_that.gn.Organisations[i].id == _that.gr.id) {
          _that.gn.Organisations[i] = _data[0]
        }
      }
      _that.navCtrl.pop();
      _that.cb();
      _that.gn.tfBtn = false;
    })

  }


}



// WEBPACK FOOTER //
// ./src/pages/settings/organizationunit/editorganizationunit.ts